<ion-icon
  class="icon"
  [id]="pickerId"
  src="assets/warn_icon.svg"
  size="large"
/>

<ion-popover
  [trigger]="pickerId"
  triggerAction="click"
  side="bottom"
  alignment="center"
  reference="trigger"
  [showBackdrop]="false"
  mode="ios"
>
  <ng-template>
    <span class="hint-content">
      It looks like we can't<br/>
      reach your device<br/>
      right now. Contact<br/>
      your maintenance<br/>
      team for assistance.
    </span>
  </ng-template>
</ion-popover>
